import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-12 sm:pt-20 items-center px-4">
      <div className="max-w-3xl w-full text-center space-y-8">
        
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-navy/10 text-brand-navy font-medium text-sm mb-4">
          <SafeIcon icon={FiIcons.FiShield} />
          Pinoy General Insurance Services
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 tracking-tight">
          Are you <span className="text-brand-red">really</span> protected if disaster strikes?
        </h1>
        
        <p className="text-xl sm:text-2xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
          Most renters think their landlord's insurance covers them. <strong className="text-gray-900">It doesn't.</strong> And renter's insurance costs less than $15/month.
        </p>

        <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100 max-w-md mx-auto mt-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Take the 60-Second Risk Test</h2>
          <p className="text-gray-600 mb-8">Find out if you're uninsured, underinsured, or overpaying for coverage you don't need.</p>
          
          <Button 
            size="lg" 
            className="w-full group"
            onClick={() => navigate('/quiz')}
          >
            Start Assessment
            <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
          
          <p className="text-sm text-gray-400 mt-4 flex items-center justify-center gap-1">
            <SafeIcon icon={FiIcons.FiClock} /> Takes less than 1 minute
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 text-left mt-16 max-w-4xl mx-auto">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="w-10 h-10 bg-brand-green/10 rounded-lg flex items-center justify-center text-brand-green mb-4">
              <SafeIcon icon={FiIcons.FiCheckCircle} />
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Identify Gaps</h3>
            <p className="text-gray-600 text-sm">See exactly where you are financially vulnerable today.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="w-10 h-10 bg-brand-navy/10 rounded-lg flex items-center justify-center text-brand-navy mb-4">
              <SafeIcon icon={FiIcons.FiDollarSign} />
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Stop Overpaying</h3>
            <p className="text-gray-600 text-sm">Find out if you're paying too much for basic coverage.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="w-10 h-10 bg-brand-orange/10 rounded-lg flex items-center justify-center text-brand-orange mb-4">
              <SafeIcon icon={FiIcons.FiBookOpen} />
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Get Educated</h3>
            <p className="text-gray-600 text-sm">Learn in plain English what insurance actually covers.</p>
          </div>
        </div>

      </div>
    </div>
  );
}